module.exports = __webpack_public_path__ + "img/article_placeholder.3894546.png";